import React, {Dispatch, useState} from "react"
import {IOrder} from "../../../../../models/order"
import {useNavigate} from "react-router-dom"
import useWindowSize from "../../../../../hooks/useWindowSize"
import dayjs from "dayjs"
import classes from "./OrderHistoryLine.module.scss"
import leftFillNum from "../../../../../utils/leftFillNum"
import numberFormat from "../../../../../utils/numberFormat"
import StatusLabel from "../../../../generic/dataDisplay/StatusLabel"
import ModalEditOrder from "../../../modals/ModalEditOrder"
import LineMenu from "../../../Lines/LineMenu"

interface IOrderHistoryLineProps {
  order: IOrder
  editSuccess: Dispatch<any>
  copySuccess: Dispatch<any>
}

function OrderHistoryLine({order, editSuccess, copySuccess}: IOrderHistoryLineProps) {

  const navigate = useNavigate()
  const windowSize = useWindowSize()
  const [modalEditShown, modalEditToggle] = useState(false)
  const [modalCopyShown, modalCopyToggle] = useState(false)

  const modalEdit = modalEditShown &&
    <ModalEditOrder
      close={() => modalEditToggle(false)}
      editSuccess={editSuccess}
      editID={order.id}
    />

  const modalCopy = modalCopyShown &&
    <ModalEditOrder
      close={() => modalCopyToggle(false)}
      editSuccess={copySuccess}
      editID={order.id}
      makeCopy
    />

  const menuList = [
    {
      id: 1,
      text: "Редактировать",
      onClick: () => modalEditToggle(true)
    },
    {
      id: 2,
      text: "Копировать",
      onClick: () => modalCopyToggle(true)
    }
  ]

  const arRequestDateTime = []
  const requestDate = order.request_date && dayjs(order.request_date, "YYYY-MM-DD").format("DD.MM.YYYY")

  if (requestDate)
    arRequestDateTime.push(requestDate)

  if (order.request_time)
    arRequestDateTime.push(order.request_time)

  const arAddressFromFull = []

  if (order.city_from)
    arAddressFromFull.push(order.city_from)

  if (order.address_from)
    arAddressFromFull.push(order.address_from)

  if (order.flat_from)
    arAddressFromFull.push(`кв. ${order.flat_from}`)

  const arAddressFromShort = []

  if (order.address_from)
    arAddressFromShort.push(order.address_from)

  if (order.flat_from)
    arAddressFromShort.push(`кв. ${order.flat_from}`)

  const arAddressToFull = []

  if (order.city_to)
    arAddressToFull.push(order.city_to)

  if (order.address_to)
    arAddressToFull.push(order.address_to)

  if (order.flat_to)
    arAddressToFull.push(`кв. ${order.flat_to}`)

  const arAddressToShort = []

  if (order.address_to)
    arAddressToShort.push(order.address_to)

  if (order.flat_to)
    arAddressToShort.push(`кв. ${order.flat_to}`)

  return(
    <>
      {windowSize.width >= 992 &&
        <div className={classes.wrap}>
          <div className={classes.field}>
            <span className={classes.field_link} onClick={() => navigate(`/order/${order.id}`)}>
              {`№${leftFillNum(order.id)}`}
            </span>
          </div>
          <div className={classes.field}><div>{arAddressFromFull.length ? arAddressFromFull.join(", ") : "-"}</div></div>
          <div className={classes.field}><div>{arAddressToFull.length ? arAddressToFull.join(", ") : "-"}</div></div>
          <div className={[classes.field].join(" ")}>
            <span>{requestDate}<br/>{order.request_time}</span>
          </div>
          <div className={[classes.field, classes.field_price].join(" ")}><span>{order.price ? `${numberFormat(order.price)} руб.` : "-"}</span></div>
          <div className={[classes.field, classes.field_weight].join(" ")}><span>{order.client_weight ? `${order.client_weight} кг` : "-"}</span></div>
          <div className={classes.field}><StatusLabel id={Number(order.status_id)} type={"order"}/></div>
          <div className={classes.field}><LineMenu items={menuList}/></div>
        </div>
      }
      {windowSize.width < 992 &&
        <div className={classes.wrap}>
          <div className={[classes.column, classes.column_order].join(" ")}>
            <div className={classes.order}>
              <div className={classes.order_date}>
                {arRequestDateTime.length ? arRequestDateTime.join(", ") : "-"}
              </div>
              <div className={classes.order_status}>
                <StatusLabel id={Number(order.status_id)} type={"order"}/>
              </div>
              <div className={classes.order_id}>
                <span className={classes.order_id_link} onClick={() => navigate(`/order/${order.id}`)}>
                  {`№${leftFillNum(order.id)}`}
                </span>
              </div>
            </div>
          </div>
          <div className={[classes.column, classes.column_waypoint].join(" ")}>
            <div className={classes.waypoint}>
              <div className={classes.waypoint_item}>
                <div className={classes.waypoint_address}>{arAddressFromShort.length ? arAddressFromShort.join(", ") : "-"}</div>
                <div className={classes.waypoint_city}>{order.city_from || `-` }</div>
              </div>
              <div className={classes.waypoint_item}>
                <div className={classes.waypoint_address}>{arAddressToShort.length ? arAddressToShort.join(", ") : "-"}</div>
                <div className={classes.waypoint_city}>{order.city_to || `-` }</div>
              </div>
            </div>
          </div>
          <div className={[classes.column, classes.column_props].join(" ")}>
            <div className={classes.props}>
              <div className={classes.props_item}>
                {order.price ? `${numberFormat(order.price)} руб.` : `-`}
              </div>
              <div className={classes.props_item}>
                {order.price ? `${order.client_weight} кг` : `-`}
              </div>
            </div>
          </div>
          <div className={[classes.column, classes.column_menu].join(" ")}>
            <LineMenu items={menuList}/>
          </div>
        </div>
      }
      {modalEdit}
      {modalCopy}
    </>
  )
}

export default OrderHistoryLine